import { ScheduleDeliverySubscription } from 'common/notifications/api/ScheduleDeliveryAPI';
import { ScreenshotSubscription } from 'common/notifications/api/ScreenshotSubscriptionsAPI';

// Frontend discriminated union types
export type ScheduleDeliverySubscriptionWithType = ScheduleDeliverySubscription & {
  type: 'scheduled_delivery';
};
export type ScreenshotSubscriptionWithType = ScreenshotSubscription & { type: 'watch' };
export type SubscriptionWithType = ScheduleDeliverySubscriptionWithType | ScreenshotSubscriptionWithType;

// Type guard functions
export const isScheduleDeliverySubscription = (
  subscription: ScreenshotSubscription | ScheduleDeliverySubscription,
): subscription is ScheduleDeliverySubscription => {
  return subscription?.attachments !== undefined && subscription?.attachments !== null;
};
